import { render, staticRenderFns } from "./new-structure.vue?vue&type=template&id=a736e22a"
import script from "./new-structure.vue?vue&type=script&lang=js"
export * from "./new-structure.vue?vue&type=script&lang=js"
import style0 from "./new-structure.vue?vue&type=style&index=0&id=a736e22a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports